import $x from '@/utils/$x';

/**
 * 查询欢迎语列表
 * @param {*} params
 * @returns
 */
export async function getGreetList(params) {
  return $x.post('/v1/litta/greet/list', params);
}

/**
 * 新增欢迎语
 * @param {*} params
 * @returns
 */
export async function addGreet(params) {
  return $x.post('/v1/litta/greet/add', params);
}

/**
 * 删除欢迎语
 * @param {*} params
 * @returns
 */
export async function delGreet(params) {
  return $x.post('/v1/litta/greet/delete', params);
}

/**
 * 更新欢迎语
 * @param {*} params
 * @returns
 */
export async function updateGreet(params) {
  return $x.post('/v1/litta/greet/update', params);
}
/**
 * 更新欢迎语
 * @param {*} params
 * @returns
 */
export async function getGreetInfo(params) {
  return $x.post('/v1/litta/greet/get', params);
}
